











import Vue from "vue";
import { PettEvaluation } from "@tt-app/models/internal/pett";

interface Computed {
  highlights: (number | undefined)[];
  splitSentence: {
    word: string;
    highlight: boolean;
  }[];
  underlines: (number | undefined)[];
}

interface Props {
  answer: any;
  evaluation: PettEvaluation;
  sentence: string;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "IntonationSentence",
  props: {
    answer: {
      type: Object,
      default: () => ({})
    },
    evaluation: {
      type: Object,
      required: true
    },
    sentence: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      modal: {
        open: false
      }
    };
  },
  computed: {
    highlights() {
      if (!this.evaluation) return [];

      return this.evaluation.results.elements
        .map((element, index) => {
          return element.composition[0].stressed ? index : undefined;
        })
        .filter(element => element !== undefined);
    },
    splitSentence() {
      const words = this.sentence.split(" ");

      return words.map((word: string, index: number) => {
        return {
          word,
          highlight: this.highlights.includes(index),
          underline: this.underlines.includes(index)
        };
      });
    },
    underlines() {
      return this.answer.intonation
        .map((intonation: any, index: number) => {
          return intonation.composition[0].stressed ? index : undefined;
        })
        .filter((element: any) => element !== undefined);
    }
  }
});
